import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { api } from "../lib/api";

export default function LegalPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setLoading(true);
    setNotFound(false);
    api
      .get(`/pages/${slug}`)
      .then(({ data }) => setPage(data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [slug]);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <section className="max-w-3xl mx-auto w-full px-5 sm:px-8 py-14 flex-1">
        <Link to="/" className="inline-flex items-center gap-2 text-sm font-semibold text-navy-soft hover:text-brand-dark transition-colors mb-6">
          <ArrowLeft className="w-4 h-4" /> Torna alla home
        </Link>

        {loading ? (
          <div className="text-navy-soft py-20 text-center">Caricamento…</div>
        ) : notFound ? (
          <div className="bg-surface rounded-2xl border border-line py-20 text-center" data-testid="page-not-found">
            <FileText className="w-10 h-10 text-navy-soft mx-auto mb-4" />
            <h1 className="font-heading font-bold text-2xl text-navy">Pagina non trovata</h1>
            <p className="mt-2 text-navy-soft text-sm">Il contenuto richiesto non esiste o non è pubblicato.</p>
          </div>
        ) : (
          <article data-testid="legal-page">
            <h1 className="font-heading font-extrabold text-4xl text-navy" data-testid="legal-title">{page.title}</h1>
            {page.updated_at && (
              <p className="mt-2 text-xs text-navy-soft">Ultimo aggiornamento: {new Date(page.updated_at).toLocaleDateString("it-IT")}</p>
            )}
            <div className="mt-8 space-y-4 text-navy leading-relaxed" data-testid="legal-content">
              {(page.content || "").trim()
                ? page.content.split(/\n{2,}/).map((para, i) => (
                    <p key={i} className="whitespace-pre-wrap">{para}</p>
                  ))
                : <p className="text-navy-soft italic">Contenuto non ancora disponibile.</p>}
            </div>
          </article>
        )}
      </section>
      <Footer />
    </div>
  );
}
